// src/utils/meta.js

export default function getDefaultMeta(title = '', keywords = '', description = '') {
  return {
    title: title || 'CFDCC',
    meta: [
      {
        name: 'keywords',
        content: keywords || 'CFDCC, COIN, USDT, BTC, ETH, 虚拟货币交易所'
      },
      {
        name: 'description',
        content: description || 'CFDCC | Provide leading digital currency trading services, safe and stable, supporting multiple currencies。'
      }
    ]
  }
}
